import callback from "./abi";

import { 
  BundleItem,
  Debot,
  Info,
  address
 } from "../interfaces";
//import * as browser from "debot-browser"; 
const browser = import("debot-browser");

export const Debots:Map<string, Debot> = new Map([
  ['debots', {
    title: 'debots',
    name: 'https://mainnet.evercloud.dev/e0a940e339b34e6ab3bdd13f1f08a52d',
    alias: 'mainnet',
    address: '0:c6ddda3413ae9738f54582062c479aad64890be7d0795379443bbcaac67102c7'
  }],

  ['token', {
    title: 'token',
    name: 'https://mainnet.evercloud.dev/e0a940e339b34e6ab3bdd13f1f08a52d',
    alias: 'mainnet',
    address: '0:be358a444895ed16532a3ec901ea25d6f1f766bf5921833e4cec87f8b8dd7aba'
  }]
]);

const logger = console;

export default class DebotClient {
  static convert = (from: any, to: any) => (data: any) => Buffer.from(data, from).toString(to);

  static hexToUtf8 = DebotClient.convert('hex', 'utf8');
  static utf8ToHex = DebotClient.convert('utf8', 'hex');

  private static browserDebotHandle: Promise<BigInt>;
  private static browserTokenHandle: Promise<BigInt>;

  constructor () {
    DebotClient.init();
  }
  
  static async init () {
    DebotClient.browserDebotHandle = new Promise(async (resolve, eject) => (await browser).create_browser(Debots.get('debots')!.name, Debots.get('debots')!.address).then((handle) => resolve(handle)));
    DebotClient.browserTokenHandle = new Promise(async (resolve, eject) => (await browser).create_browser(Debots.get('token')!.name, Debots.get('token')!.address).then((handle) => resolve(handle)));
  }

  private static buildTokenManifest = (func: any, args: any) => {
    return `{
      "version": 0,
      "debotAddress": "${Debots.get("token")?.address}",
      "initMethod": "${func}",
      "initArgs": ${args},
      "quiet": true,
      "chain": [],
      "abi": ${callback.abi}
    }`;
  };

  static async getInfo():Promise<Info> {
    (await browser);
    (await DebotClient.browserTokenHandle);
    logger.log(`Calling getSaleInfo...\n`);
    const manifest = DebotClient.buildTokenManifest("invokeGetSaleInfo", "{}");
    console.log(manifest);
    console.log(await DebotClient.browserTokenHandle);
    const result = (await browser).run_debot_browser(Debots.get("token")!.name, null, null, null, manifest)
    // const result = (await browser).run_browser((await DebotClient.browserTokenHandle), manifest)
    .then(result => JSON.parse(result))
    .catch(error => error);
    return await result;
  }

  /**
   * Get JSON manifest for browser request
   * TODO proper typization for func and args prop
   **/
   private static buildGetDebotsManifest (debot: Debot = Debots.get("debots")!): JSON {
    // return JSON.parse(`{"version":0,"debotAddress":"${debot.address}","initMethod":"getDebotsList","initArgs":{},"quiet":false,"abi":{"ABIversion":2,"version":"2.2","header":["time"],"functions":[{"name":"onGetDeBotsList","inputs":[{"components":[{"name":"addr","type":"address"},{"components":[{"name":"name","type":"string"},{"name":"version","type":"string"},{"name":"publisher","type":"string"},{"name":"caption","type":"string"},{"name":"author","type":"string"},{"name":"support","type":"address"},{"name":"hello","type":"string"},{"name":"language","type":"string"},{"name":"icon","type":"bytes"}],"name":"info","type":"tuple"},{"name":"codeStatus","type":"uint8"}],"name":"list","type":"tuple[]"}],"outputs":[]}]},"chain":[]}`);
    return JSON.parse(`{"version":0,"debotAddress":"${debot.address}","initMethod":"getDebotsList","interactive":false,"quiet":true,"abi":{"ABIversion":2,"version":"2.2","header":["pubkey","time","expire"],"functions":[{"name":"onGetDeBotsList","inputs":[{"components":[{"name":"addr","type":"address"},{"name":"hash","type":"uint256"},{"components":[{"name":"name","type":"string"},{"name":"version","type":"string"},{"name":"publisher","type":"string"},{"name":"caption","type":"string"},{"name":"author","type":"string"},{"name":"support","type":"address"},{"name":"hello","type":"string"},{"name":"language","type":"string"},{"name":"icon","type":"bytes"}],"name":"info","type":"tuple"}],"name":"list","type":"tuple[]"}],"outputs":[]},{"name":"constructor","inputs":[],"outputs":[]}],"data":[],"events":[],"fields":[{"name":"_pubkey","type":"uint256"},{"name":"_timestamp","type":"uint64"},{"name":"_constructorFlag","type":"bool"}]},"chain":[]
  }`);
  };

  /**
   * Get JSON manifest for browser request
   * TODO proper typization for func and args prop
   **/
   private static buildDebotsManifest (address: address): JSON {
    return JSON.parse(`{"version":0,"debotAddress":"${address}","initMethod":"getDebotsList","initArgs":{},"quiet":true,"abi":{"ABI version":2,"version":"2.2","header":["time"],"functions":[{"name":"onGetDeBotsList","inputs":[{"components":[{"name":"addr","type":"address"},{"components":[{"name":"name","type":"string"},{"name":"version","type":"string"},{"name":"publisher","type":"string"},{"name":"caption","type":"string"},{"name":"author","type":"string"},{"name":"support","type":"address"},{"name":"hello","type":"string"},{"name":"language","type":"string"},{"name":"icon","type":"bytes"}],"name":"info","type":"tuple"},{"name":"codeStatus","type":"uint8"}],"name":"list","type":"tuple[]"}],"outputs":[]}]},"chain":[]}`);
  };

  /**
   * Get trading pairs with trading metadata
   **/
   static async getDebots(): Promise<{list: BundleItem[]}> {
    (await browser);
    (await DebotClient.browserDebotHandle);
    logger.log(`Calling getDebots...\n`);
    const manifest = DebotClient.buildGetDebotsManifest();
    return await (await browser).run_browser((await DebotClient.browserDebotHandle), manifest);
  }
  /**
   * Get trading pairs with trading metadata
   **/
  static async postDebot(address: address): Promise<{tokens: BundleItem[]}> {
    logger.log(`Calling getDebots...\n`);
    const manifest = DebotClient.buildDebotsManifest(address);
    // return await (await browser).run_browser((await DebotClient.browserDebotHandle), manifest);
    return await (await browser).run_debot_browser(Debots.get("debots")!.name, null, null, null, manifest);
  }

}

(async () => {
  new DebotClient();
})()

